import { useEffect, useRef, useState } from "react";

function uuid4() {
    // RFC4122 v4 - works in preview without crypto.randomUUID on older Safari.
    const bytes = new Uint8Array(16);
    (window.crypto || window.msCrypto).getRandomValues(bytes);
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const h = [...bytes].map((b) => b.toString(16).padStart(2, "0"));
    return `${h.slice(0, 4).join("")}-${h.slice(4, 6).join("")}-${h
        .slice(6, 8)
        .join("")}-${h.slice(8, 10).join("")}-${h.slice(10, 16).join("")}`;
}

/**
 * Eine stabile client_operation_id pro Flow-Mount.
 * Wird nach erfolgreichem Submit mit `rotate()` neu generiert,
 * sodass der Flow beim Weiter-Scan eine frische UUID verwendet.
 */
export function useFlowOperationId() {
    const [id, setId] = useState(() => uuid4());
    const ref = useRef(id);
    useEffect(() => {
        ref.current = id;
    }, [id]);
    return {
        clientOperationId: id,
        ref,
        rotate: () => setId(uuid4()),
    };
}

export { uuid4 };
